module.exports = __webpack_public_path__ + "static/media/robokassa.ed0edcbf.png";